export namespace Logging {
  export enum LogLevel {
    Error,
    Warn,
    Debug
  }

  export function logWarn(logLevel: LogLevel, args: any[]) {
    if (logLevel >= LogLevel.Warn) {
      console.log(args);
    }
  }

  export function logDebug(logLevel: LogLevel, args: any[]) {
    if (logLevel >= LogLevel.Debug) {
      console.log(args);
    }
  }

  export function logDebugDir(logLevel: LogLevel, tag: string, object: any) {
    if (logLevel >= LogLevel.Debug) {
      console.log(tag + ":");
      console.dir(object);
    }
  }
}



// WEBPACK FOOTER //
// ./utils/Logging.ts